module.exports = __webpack_public_path__ + "img/1st.ab958c1c.png";